var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgConsumption(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.837,
    height: 24.133,
    viewBox: "0 0 17.837 24.133",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_14880546471658455727",
    "data-name": 14880546471658455000,
    transform: "translate(-7 -1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_43873",
    "data-name": "Path 43873",
    d: "M10.672,1C8.644,1,7,3.943,7,6.7c0,2.2,1.054,3.613,2.514,4.089L9.132,24.051a1.049,1.049,0,0,0,1.049,1.082h.983a1.049,1.049,0,0,0,1.049-1.082L11.83,10.785c1.46-.477,2.514-1.887,2.514-4.089,0-2.753-1.644-5.7-3.672-5.7Z",
    fill: "#bec4ca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43874",
    "data-name": "Path 43874",
    d: "M33.591,1.239a.3.3,0,0,0-.591,0l-.754,5.532h-.525l-.754-5.532a.3.3,0,0,0-.591,0l-.754,5.532H29.1l-.754-5.532a.3.3,0,0,0-.591,0l-.716,5.249A4.179,4.179,0,0,0,27,7.055v.613a3.148,3.148,0,0,0,2.129,2.978l.385.132L29.132,24.05a1.049,1.049,0,0,0,1.049,1.082h.983a1.049,1.049,0,0,0,1.049-1.082L31.83,10.778l.385-.132a3.148,3.148,0,0,0,2.129-2.978V7.055a4.179,4.179,0,0,0-.038-.567L33.59,1.239Z",
    transform: "translate(-9.507)",
    fill: "#bec4ca"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConsumption);
export default __webpack_public_path__ + "static/media/consumption.67642a29422ab88829d105a65f0024b2.svg";
export { ForwardRef as ReactComponent };